import React, { useState } from "react";
import { Mail, Phone } from "lucide-react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./CloudServicesPage.css";

// Assets

import heroImg from "../../assests/Background-img.svg";

// Components
import SmarterCostOptimization from "./SmarterCostOptimization";
import MultiCloudVisibility from "./MultiCloudVisibility";
import PerformanceEfficiency from "./PerformanceEfficiency";
import BusinessNeeds from "./BusinessNeeds";
import WhyChoose from "./WhyChoose";
import CTASection from "./CTASection";
import ContactFormModal from "../header/ContactFormModal";
import WhyIOTSection from "../WhyIOTSection/WhyIOTSection";
import ArBusiness from "../Ar-vrServicespage/ArBusiness";
import { useNavigate } from "react-router-dom";

// Define service type
type Service = {
  id: string;
  title: string;
  icon: string;
  items: string[];
  hasRoute: boolean;
  routePath?: string;
};

const CloudServicesPage: React.FC = () => {
  const navigate = useNavigate();
  const [activeService] = useState("cloud-solution");
    const [showContactForm, setShowContactForm] = useState(false);

  const handleServiceClick = (service: Service) => {
    if (service.hasRoute && service.routePath) {
      window.location.href = service.routePath;
    }
  };

  return (
    <div className="cloud-services-page">
      {showContactForm && <ContactFormModal onClose={() => setShowContactForm(false)} />}
      {/* Hero Section */}
<section
  className="hero-section-cloud d-flex align-items-center justify-content-center"
  style={{
    backgroundImage: `url(${heroImg})`,
    backgroundSize: "cover",
  }}
>
  <div className="container-cloud text-center">
    <h1 className="hero-title-cloud">
      Cloud & DevOps 
    </h1>
    <p className="hero-subtitle-cloud">
      Transform your enterprise with cloud solutions and DevOps practices that drive agility, scalability, and operational excellence. 
    </p>
    <button
      className=" hero-button-cloud"
      onClick={() => navigate("/Contact-Us")}
    >
      Get in Touch
    </button>
  </div>
</section>


      {/* Other Sections */}
      {/* <SmarterCostOptimization /> */}
      <MultiCloudVisibility />
      <PerformanceEfficiency />
      <BusinessNeeds />
      <WhyIOTSection />
      <ArBusiness />
    </div>
  );
};

export default CloudServicesPage;
